var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDangerousExitWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 16.5371V19.5371H25.5V16.5371H10.5ZM18 3.03711C9.72 3.03711 3 9.75711 3 18.0371C3 26.3171 9.72 33.0371 18 33.0371C26.28 33.0371 33 26.3171 33 18.0371C33 9.75711 26.28 3.03711 18 3.03711ZM18 30.0371C11.385 30.0371 6 24.6521 6 18.0371C6 11.4221 11.385 6.03711 18 6.03711C24.615 6.03711 30 11.4221 30 18.0371C30 24.6521 24.615 30.0371 18 30.0371Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerousExitWhite);
export default __webpack_public_path__ + "static/media/dangerous-exit-white.31faf6846e117287bd5c7d308debb29e.svg";
export { ForwardRef as ReactComponent };